import { createGlobalStyle, css } from 'styled-components';

const Typography = createGlobalStyle`${css`
	#smooth-content {
		will-change: transform;
	}

	body {
		position: relative;
		width: 100%;
		min-height: 100vh;
		font-family: var(--larken);
		font-weight: 400;
		line-height: var(--lineHeightL);
		color: var(--green1000);
		background-color: var(--lightGray1000);
		overflow-x: hidden;
		overflow-y: ${(props) => (props.popupIsOpen ? 'hidden' : '')};

		main {
			position: relative;
			display: flex;
			flex-direction: column;
			min-height: 100vh;
			padding-top: var(--headerFixedHeight);
			/* transition: padding-top 1s; */
			z-index: 1;

			&:has(> #full-pad:first-child) {
				padding-top: 0;
				/* transition: padding-top 0s; */
			}
		}

		&.hidden {
			overflow: hidden !important;
			max-height: 100dvh !important;
		}

		//! For IOS
		&.touch-action {
			* {
				touch-action: none;
				-ms-touch-action: none;
			}
		}

		/* //! Custom version  */
		&.filter-hidden {
			overflow: hidden !important;
			max-height: 100dvh !important;

			header {
				display: block !important;
				transform: translateY(0) !important;
			}

			/* * {
				touch-action: none;
				-ms-touch-action: none;
			} */
		}

		&.external {
			.header-inner-wrapper {
				svg path {
					fill: var(--green1000);
				}

				.selected-lang,
				.selected-lang-icon,
				.lang-item,
				.burger-open-close {
					color: var(--green1000);
				}
			}
		}
	}

	//! Font sizes
	.h1,
	.hero,
	h1 {
		font-size: var(--h1);
		line-height: var(--lineHeightS);
	}

	.h2,
	h2 {
		font-size: var(--h2);
		line-height: var(--lineHeightS);
	}

	.h3,
	.cta-section,
	h3 {
		font-size: var(--h3);
		line-height: var(--lineHeightS);
	}

	.h4,
	.subtitle1,
	h4 {
		font-size: var(--h4);
		line-height: var(--lineHeightS);
	}

	.h5,
	.subtitle2,
	h5 {
		font-size: var(--h5);
		line-height: var(--lineHeightS);
	}

	.h6,
	.product-name,
	h6 {
		font-size: var(--h6);
		line-height: var(--lineHeightS);
	}

	p {
		font-size: var(--p1);
		line-height: var(--lineHeightL);
	}

	.p,
	p,
	a,
	button,
	span,
	i {
		&.p1,
		&.body1,
		&.input {
			font-size: var(--p1);
			line-height: var(--lineHeightL);
		}

		&.p2,
		&.body2 {
			font-size: var(--p2);
			line-height: var(--lineHeightL);
		}

		&.p3,
		&.tags {
			font-size: var(--p3);
			line-height: var(--lineHeightL);
		}

		&.p4,
		&.button {
			font-size: var(--p4);
			line-height: var(--lineHeightL);
		}

		&.p5 {
			font-size: var(--p5);
			line-height: var(--lineHeightL);
		}
	}
`}`;

export default Typography;
